import moment from 'moment';

import type { TChatResizeConfig } from '../types/resizablePanel';

export const CHAT_PANEL_RESIZE: Record<'accountSplit' | 'complementSplit', TChatResizeConfig> = {
  accountSplit: {
    defaultWidth: {
      base: 340,
      wide: {
        breakpoint: 1366,
        offset: -73.3333,
        viewportRatio: 33.3333,
        maxWidth: 412,
      },
    },
    minWidth: 330,
    maxWidth: 500,
    minRemainingWidth: 420,
  },
  complementSplit: {
    defaultWidth: {
      base: 340,
      wide: {
        breakpoint: 1366,
        offset: -73.3333,
        viewportRatio: 33.3333,
        maxWidth: 360,
      },
    },
    minWidth: 310,
    maxWidth: 500,
    minRemainingWidth: 420,
  },
};

export const CHAT_PANEL_STORAGE_KEYS = {
  accountSplit: 'chatPanelAccountWidth',
  complementSplit: 'chatPanelComplementWidth',
} as const;

export const CONFIG_DATE_RANGE_ANT = {
  startDate: moment().clone().subtract(29, 'days'),
  endDate: moment().clone(),
  minDate: moment().clone().subtract(89, 'days'),
  _startDate: moment().clone().subtract(29, 'days').format('YYYY-MM-DD'),
  _endDate: moment().clone().format('YYYY-MM-DD'),
  _minDate: moment().clone().subtract(89, 'days').format('YYYY-MM-DD'),
};

export const CONFIG_DATE_RANGE_ANT7 = {
  startDate: moment().clone().subtract(6, 'days'),
  endDate: moment().clone(),
  minDate: moment().clone().subtract(89, 'days'),
  _startDate: moment().clone().subtract(6, 'days').format('YYYY-MM-DD'),
  _endDate: moment().clone().format('YYYY-MM-DD'),
  _minDate: moment().clone().subtract(89, 'days').format('YYYY-MM-DD'),
};

export const ROOT_DESTROY_DELAY = 1;

export const IGNORE_WORDS = ['as', 'to', 'xxx'];
